export type ProduceErrorModalSetters = {
  setShowProduceErrorModal: (value: boolean) => void;
  setIsContentModerationError: (value: boolean) => void;
  setModerationReason: (value: string) => void;
};

export function getApiErrorMessage(error: unknown): string {
  if (
    error &&
    typeof error === 'object' &&
    'response' in error &&
    (error as { response?: { data?: unknown } }).response?.data != null
  ) {
    const data = (error as { response: { data: unknown } }).response.data;
    if (typeof data === 'object' && data !== null && 'message' in data) {
      const m = (data as { message: unknown }).message;
      if (typeof m === 'string') return m;
      if (Array.isArray(m)) return m.filter(Boolean).join(' ');
    }
  }
  if (error instanceof Error) return error.message;
  return '';
}

/** Opens produce error modal; sets moderation copy when API message indicates policy block. */
export function applyProduceErrorModalFromApiError(
  error: unknown,
  setters: ProduceErrorModalSetters,
): void {
  const errorMessage = getApiErrorMessage(error);

  const isContentModeration =
    errorMessage.toLowerCase().includes('content moderation') ||
    errorMessage.toLowerCase().includes('moderation');

  setters.setIsContentModerationError(isContentModeration);
  if (isContentModeration) {
    setters.setModerationReason(
      errorMessage.replace(/^content moderation:\s*/i, '').trim(),
    );
  } else {
    setters.setModerationReason('');
  }
  setters.setShowProduceErrorModal(true);
}
